import React, { Fragment, useContext, useEffect } from 'react';
import { formatPostDate } from '@mummssoftware/utils/formatters';
import {
  ElectionAddendum,
  EA_NOTE_TRIGGER_TYPE,
  EA_TRIGGER_SOURCE_PROGRESS_NOTE,
  error,
} from '@mummssoftware/utils/constants';
import { OrdersGlobalContext } from '@mummssoftware/global-context/OrdersGlobalContext';
import { Context } from '../../context';
import { ProgressNotesContext } from '../Context/ProgressNotesContext';
import { SET_API_ERROR, EA } from '../Context/constants';
import {
  StyledMenuSpan,
  MenuDiv,
  MenuContentDiv,
} from '../../components/layout/WrapperDiv';
import defaults from '../../translations/en.json';

type EAMenuProps = {
  note: mumms.progressNotebyEntity | mumms.progressNote | null;
};

const EAMenu = ({ note }: EAMenuProps) => {
  const {
    updateProgressNoteEntity,
    updateProgressNotes,
    refreshPatientHeader,
    agency,
    patient,
    currentUser,
    workflow,
  } = useContext(Context);
  const { savedNote } = useContext(OrdersGlobalContext);
  const { closeTagMenu, dispatch } = useContext(ProgressNotesContext);

  const alertError = (message: string) => {
    dispatch &&
      dispatch({
        type: SET_API_ERROR,
        payload: { message, severity: error },
      });
  };

  const postElectionAddendumTrigger = async (noteId: string | number) => {
    const patientId = String(patient.patientId ?? patient.id ?? '');
    if (!patientId || !workflow) {
      console.error(
        'Election addendum trigger skipped: missing patientId or workflow',
      );
      alertError(defaults.errorEATrigger);
      return;
    }
    const response = await workflow.addElectionAddendumTrigger(
      {
        patientId,
        triggerDate: formatPostDate(new Date()),
        type: EA_NOTE_TRIGGER_TYPE,
        source: EA_TRIGGER_SOURCE_PROGRESS_NOTE,
        sourceValue: String(noteId),
        comment: ElectionAddendum,
      },
      agency,
    );
    if (response instanceof Response) {
      console.error('Election addendum trigger failed', response.status);
      alertError(defaults.errorEATrigger);
      return;
    }
    await refreshPatientHeader(patient.patientNumber, agency);
  };

  const updatePNoteEntity = async (progressNoteEntityData: any) => {
    const entitySaved = await updateProgressNoteEntity(
      agency,
      progressNoteEntityData,
      'POST',
      defaults.errorEATag,
    );
    if (entitySaved) {
      await postElectionAddendumTrigger(
        progressNoteEntityData.patientprogressnoteid,
      );
    }
    closeTagMenu();
  };

  const updatePNotes = async () => {
    await updateProgressNotes(patient.patientNumber, agency);
  };

  useEffect(() => {
    if (note?.id) {
      const progressNoteEntityData = {
        entitykey: '-1',
        entitytypeshortname: EA,
        entityname: ElectionAddendum,
        patientprogressnoteid: note.id,
        createdatetime: formatPostDate(new Date()),
        createpersonid: currentUser?.userId,
        createpersonnumber: currentUser?.personNumber,
      };
      updatePNoteEntity(progressNoteEntityData);
    }
    return () => {
      if (!savedNote && note?.id) {
        updatePNotes();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getMenuContent = () =>
    note ? (
      <MenuDiv>
        <MenuContentDiv>{defaults.tagEA}</MenuContentDiv>
      </MenuDiv>
    ) : (
      <StyledMenuSpan>{defaults.noNote}</StyledMenuSpan>
    );

  return <Fragment>{getMenuContent()}</Fragment>;
};

export default EAMenu;
